import styled from "styled-components";
import { motion } from "framer-motion";

export const PageTransitionShell = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const MotionPageLayer = styled(motion.div)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const PageTransitionFallbackShell = styled.div`
  flex: 1;
  min-height: 0;
  width: 100%;
`;
